<h3>
  <label>ECMS</label>
  <ng-container style="display:inline-block">
    <button (click)="exportCSV()" id="export_button">Export as .csv</button>
  </ng-container>
  <ng-container style="display:inline-block">
    <button [style.background-color]="getColor(uploadFlag)" (click)="displayUpload()">Modify</button>
  </ng-container>
  <ng-container style="display:inline-block">
    <button [style.background-color]="getColor(removeFlag)" (click)="displayRemove()">Remove</button>
  </ng-container>
  <ng-container style="display:inline-block">
    <button [style.background-color]="getColor(allFlag)" (click)="displayAll()">All</button>
  </ng-container>
  <ng-container style="display:inline-block">
    <button [style.background-color]="getColor(preFlag)" (click)="displayPreApp()">PreApproved</button>
  </ng-container>
  <ng-container style="display:inline-block">
    <button [style.background-color]="getColor(geoFlag)" (click)="displayNoGeo()">No GeoPal</button>
  </ng-container>
    <ng-container style="display:inline-block">
    <button [style.background-color]="getColor(offlineFlag)" (click)="displayOffline()">Offline</button>
  </ng-container>
  <ng-container style="display:inline-block">
    <button [style.background-color]="getColor(rawFlag)" (click)="displayRaw()">Raw Ecms</button>
  </ng-container>
  <ng-container style="display:inline-block">
    <span>Count: {{rowCount}}</span>
  </ng-container>
</h3>
<ng-container *ngIf="uploadFlag; else sendlabel" style="display:inline;">
  <upload-ecms (open_close)="receiveFlag($event)" [inMprnList]="headerMPRNList"></upload-ecms>
</ng-container>
<ng-container *ngIf="removeFlag; else sendlabel" style="display:inline;">
  <remove-ecms (open_close)="receiveFlag($event)"></remove-ecms>
</ng-container>
<ng-template #sendlabel>
</ng-template>
<div>
  <ecms-table #child (rowCountEvent)="receiveCount($event)" (mprnList)="receiveMPRNList($event)"></ecms-table>
</div>
